<script>

	import { onMount } from "svelte";
	import { csv, autoType } from "d3";
	import TitleLogo from "./components/TitleLogo.svelte";
	import IntroSection from "./components/IntroSection.svelte";
	import InteractiveMap from './components/InteractiveMap.svelte';
	// import CitiesKDE from './components/CitiesKDE.svelte';
	// import CitiesKDEtween from './components/CitiesKDEtween.svelte';
	// import CitiesKDEtweenPop from './components/CitiesKDEtweenPop.svelte';
	// import Beeswarm from './components/Beeswarm.svelte';
	import DistPlot from './components/DistPlot.svelte';
	// import CitiesParallelPlot from './components/CitiesParallelPlot.svelte';
	
	let darkMode = true;
	let aggData = [];
	let metroData = [];
	let loaded = false;
	let lang = "en";
	$: exampleCities = innerWidth>640?["Toronto, Canada", "New York, United States", "Monterrey, Mexico", "Jakarta, Indonesia", "Orlando, United States", "Bogota, Colombia"]:["New York, United States", "Monterrey, Mexico", "Jakarta, Indonesia", "Orlando, United States", "Bogota, Colombia"]
	$: outerWidth = 0;
	$: innerWidth = 0;
	$: outerHeight = 0;
	$: innerHeight = 0;

	// theme
	$: mainDrawColor = darkMode === true? "#ccc": "rgb(44, 44, 44)"
	$: mainTitleColor = darkMode === true? "white": "rgb(44, 44, 44)"
	$: mainSpecialColor = darkMode === true? "#fbb61a": "#6e016b"
	$: mainSpecialColorActive = darkMode === true? "#ffe26e": "#b504b0"
	// $: mainBgColor = darkMode === true? "black": "rgb(248, 248, 248)"
	$: mainBgColor = darkMode === true? "#040404": "rgb(248, 248, 248)"
	$: mainBgColorControls = darkMode === true? "rgb(20, 20, 20)": "rgb(248, 248, 248)"
	$: mainBorderColor = darkMode === true? "#ccc": "rgb(44, 44, 44)"
	// // change background color if light mode is on
	// $: document.body.style.backgroundColor = mainBgColor


	onMount(async () => {

		await csv("/data/access_agg_pop.csv", autoType).then((data)=>{
			aggData = 
			// data
			data.map(d=>({...d, 
					accessibility: 
					(d.nightlife+d.active_living+d.mobility+d.health_wellbeing+d.community_space+d.food_choices+d.education)/7,
					fifteenPropAccess:+((+d.fifteenPopAccess/+d.P15)*100)
				}))
			metroData=innerWidth>500?aggData.filter(d=>d.P15>500000):aggData.filter(d=>d.P15>700000)
		}).then(()=>{loaded=true})
		
	})
		

</script>

<svelte:window bind:innerWidth bind:outerWidth bind:innerHeight bind:outerHeight />
<meta charset="utf-8">
<title>UrbanAccessMap</title>
<main id="mainContent" style="background-color: {mainBgColor}">
<!-- TITLE Section-->
<section style="position: relative">
	<!-- <TitleLogo {mainTitleColor} {mainSpecialColor}/>
	<IntroSection {mainDrawColor}/> -->

	<!-- <CitiesKDE {aggData} {mainDrawColor} {mainSpecialColor} {innerWidth}/> -->

	<!-- <CitiesKDEtween {aggData} {mainDrawColor} {mainSpecialColor} {mainBorderColor} {mainBgColorControls} {innerWidth}/>
	<CitiesParallelPlot {aggData} {mainDrawColor} {mainSpecialColor} {mainBorderColor} {mainBgColorControls} {innerWidth}/> -->
	<!-- <CitiesKDEtweenPop {aggData} {mainDrawColor} {mainSpecialColor} {mainBorderColor} {mainBgColorControls} {innerWidth}/> -->

	<!-- <Beeswarm {aggData} {mainDrawColor} {mainSpecialColor} {mainBorderColor} {mainBgColorControls} {innerWidth} country={"United States"} selectedCity={"New York, United States"}/> -->
	<!-- <DistPlot {aggData} {mainDrawColor} {mainSpecialColor} {mainBorderColor} {mainBgColorControls} {innerWidth} country={"United States"} selectedCity={"New York, United States"}/> -->
	<!-- <div style="text-align:center;z-index:10">
		{#if loaded===true}
			<DistPlot data = {metroData} {mainDrawColor} {mainSpecialColor} {mainBorderColor} {mainBgColorControls} {innerWidth} country={"World"} selectedCity={exampleCities} fifteenMinProp={90} width={innerWidth*0.9} axisLabel = {true}/>
		{/if}
	</div> -->
</section>

<!-- <div id="spacer" style="width: 200px; height: 25px; margin-right:0px;"></div> -->
<!-- MAP -->
<section style="position: relative">
<!-- {mainBgColor}
{mainDrawColor}
{mainSpecialColor}
{mainTitleColor}
{mainBgColorControls}
{mainBorderColor}
{mainSpecialColorActive} -->

{#if loaded===true}
	<svelte:component 
	this={InteractiveMap}
	{aggData}
	{darkMode}
	{innerWidth}
	{innerHeight}
	{metroData}
	{exampleCities}
	/>
{/if}
</section>
	
</main>

<style>
	main {
		/* text-align: center; */
		/* padding: 1em;
		max-width: 240px; */
		margin: 0 auto;
	}

	#infoPoint:hover {
        font-weight: 900;
        cursor: pointer
	}

	#infoPopup {
		position: absolute;
		z-index:100;
		width: 84vw;
		height: 84vh;
		opacity: 0.9;
		text-align: left;
		padding-left: 4%;
		padding-right: 4%;
		overflow: scroll
		/* transform: translate(10vw, 10vh); */
		/* background-color: rgb(20, 20, 20); */
	}

	.sliderFlex {
		margin-bottom: 0;
		margin-top:auto
	}
	.infolink:before {
		content: '?';
		display: inline-block;
		font-family: sans-serif;
		font-weight: bold;
		text-align: center;
		width: 1.8ex;
		height: 1.8ex;
		/* font-size: 1.4ex; */
		line-height: 1.8ex;
		border-radius: 1.2ex;
		margin-right: 4px;
		padding: 1px;
		color: grey;
		background: none;
		border: 1px solid grey;
		text-decoration: none;
	}

	.infolink:hover:before {
		color: white;
		background: grey;
		border-color: white;
		text-decoration: none;
	}

	.appTitle {
		font-family: 'Josefin Sans', sans-serif;
		/* font-family: halyard-micro, sans-serif !important; */
		font-weight: 700;
		/* text-transform: uppercase; */
	}

	#infoPoint {
        font-weight: 900;
        font-size: 30px;
		position: absolute;
		text-align: right;
		/* text-align: right; */
		/* text-align: right; */
	}	
	
	#cuspLogo {
		position: absolute;
		text-align: right;
	}

	.weightSlider {
		display: flex;
		flex-direction: column;
		font-size: 13px;
		/* line-height: 0.02em; */
		text-align: left;
		margin-left: 10px;
		max-width: 150px;
		vertical-align: text-bottom;
		margin-bottom: 0;
		margin-top:auto;
	}

	.resetButton {
		max-width: 150px;
		margin-bottom: auto;
		margin-top:40%;
		margin-left: 10px;
		text-transform: uppercase;
		cursor: pointer;
	}

	#smartphoneFilterButton {
		max-width: 50px;
		height: 100px;
		cursor: pointer;
		text-transform: uppercase;
	}

	#smartphoneFilterButton span {
		display: inline-block;
    	transform: rotate(90deg) translate(0px, 15px);
		 /* Safari */
		-webkit-transform: rotate(90deg) translate(0px, 15px);

		/* Firefox */
		-moz-transform: rotate(90deg) translate(0px, 15px);

		/* IE */
		-ms-transform: rotate(90deg) translate(0px, 15px);

		/* Opera */
		-o-transform: rotate(90deg) translate(0px, 15px);
	}

	.closeButton {
		position:absolute; 
		max-height:27px;
		font-weight:900;
		cursor:pointer;					
	}

	.label:first-child {
		float: left;
	}
	.label:last-child {
		float: right;
	}
	#console {
		position: absolute;
		/* width: 25vw; */
		width: 310px;
		max-width: 100vw;
		margin: 10px;
		padding: 10px 20px;
		text-align: left;
		opacity: 0.95;
		font-size: 15.3px;
		border-width: 2px;
		/* background-color: white; */
	}

	#access {
		position: absolute;
		top: 0;
		bottom: 0;
		width: 100%;
	}

	/* h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	} */

	/* @media (min-width: 640px) {
		main {
			max-width: none;
		}
	} */

	#citiesSelect {
      cursor:pointer;
      max-width: 215px;
      height:40px;
      /* color:#ccc; */
      font-weight:500;
      font-size: 16px;
      text-transform: uppercase;
	  /* border-width: 2px; */
      /* border-color: #ccc; */
      /* margin-top: 10px; */
	  margin:15px
	  /* transform:translate(18px,10px) */
    }
	.citiesSelect {
      cursor:pointer;
      max-width: 215px;
	  min-width: 215px;
      height:40px;
      /* color:#ccc; */
      font-weight:500;
      font-size: 14px;
      /* text-transform: uppercase; */
	  border-width: 2px;
      /* border-color: #ccc; */
      /* margin-top: 10px; */
	  margin:15px
	  /* transform:translate(18px,10px) */
    }

	/* #citiesSelect:hover {
		background-color: #fbb61a;
	} */

	.mapboxgl-popup-content {
	color: #ccc;
	}

	td {
	color: #ccc;
	border-bottom:1px solid black;
	border-bottom-width: 0px;
	z-index:0
	}

	.tableSep {
	border-left:1px solid #ccc;
	text-align: center;
	z-index:1
	}

	th {
	text-transform: uppercase;
	color: #ccc;
	border: none;
	}

	table, th, td {
	border-collapse: collapse;
	font-size:12px
	}

	.rounded-rect {
	background: black;
	opacity: 0.7;
	border-radius: 10px;
	box-shadow: 0 0 50px -25px black;
	}
	
	.flex-center {
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	}
	
	.flex-center.left {
	left: 0px;
	}
	
	.flex-center.right {
	right: 0px;
	}
	
	.sidebar-content {
	position: absolute;
	width: 95%;
	height: 95%;
	font-family: Arial, Helvetica, sans-serif;
	font-size: 32px;
	color: #ccc;
	}
	
	.sidebar-toggle {
	position: absolute;
	width: 1.3em;
	height: 1.3em;
	overflow: visible;
	display: flex;
	justify-content: center;
	align-items: center;
	}
	
	.sidebar-toggle.left {
	right: -1.5em;
	}
	
	.sidebar-toggle.right {
	left: -1.5em;
	}
	
	.sidebar-toggle:hover {
	color: orange;
	cursor: pointer;
	}
	
	.sidebar {
	transition: transform 1s;
	z-index: 1;
	width: 400px;
	height: 100%;
	}
	
	/*
	The sidebar styling has them "expanded" by default, we use CSS transforms to push them offscreen
	The toggleSidebar() function removes this class from the element in order to expand it.
	*/
	.left.collapsed {
	transform: translateX(-395px);
	}
	
	.right.collapsed {
	transform: translateX(395px);
	}
</style>